export const KPI_TIER_RED_MAX = 2.0
export const KPI_TIER_GREEN_MIN = 3.5

export const OVERALL_PERFORMANCE_STYLES = {
	green: {
		pillBg: "#e8f5e9",
		textColor: "#2e7d32",
		borderColor: "#a5d6a7",
	},
	yellow: {
		pillBg: "#fff8e1",
		textColor: "#f57f17",
		borderColor: "#ffe082",
	},
	red: {
		pillBg: "#ffebee",
		textColor: "#c62828",
		borderColor: "#ef9a9a",
	},
	default: {
		pillBg: "#f5f5f5",
		textColor: "#757575",
		borderColor: "#e0e0e0",
	},
}

export function parseKpiScores(delivery, quality, support) {
	return [delivery, quality, support]
		.map((value) => {
			if (value === null || value === undefined || value === "") {
				return NaN
			}
			const parsed = Number(value)
			return Number.isFinite(parsed) ? parsed : NaN
		})
		.filter((value) => !isNaN(value))
}

export function calculateKpiMean(delivery, quality, support) {
	const scores = parseKpiScores(delivery, quality, support)
	if (scores.length === 0) {
		return null
	}
	return scores.reduce((sum, value) => sum + value, 0) / scores.length
}

export function getOverallPerformanceTier(delivery, quality, support) {
	const scores = parseKpiScores(delivery, quality, support)
	if (scores.length === 0) {
		return null
	}

	const mean = scores.reduce((sum, value) => sum + value, 0) / scores.length

	if (mean < KPI_TIER_RED_MAX) {
		return "red"
	}
	if (mean > KPI_TIER_GREEN_MIN) {
		return "green"
	}
	return "yellow"
}

export function getOverallPerformanceStyle(delivery, quality, support) {
	const tier = getOverallPerformanceTier(delivery, quality, support)
	if (!tier) {
		return OVERALL_PERFORMANCE_STYLES.default
	}
	return OVERALL_PERFORMANCE_STYLES[tier]
}

export function getOverallPerformanceLabel(delivery, quality, support) {
	const tier = getOverallPerformanceTier(delivery, quality, support)
	if (!tier) {
		return ""
	}
	return tier.charAt(0).toUpperCase() + tier.slice(1)
}

const KPI_SCORE_BADGE_STYLES = {
	1: OVERALL_PERFORMANCE_STYLES.red,
	5: OVERALL_PERFORMANCE_STYLES.green,
}

export function getKpiScoreBadgeStyle(value) {
	if (value === null || value === undefined || value === "") {
		return null
	}
	const parsed = Number(value)
	if (!Number.isFinite(parsed)) {
		return null
	}
	if (parsed === 1) {
		return KPI_SCORE_BADGE_STYLES[1]
	}
	if (parsed === 5) {
		return KPI_SCORE_BADGE_STYLES[5]
	}
	return null
}

export function formatKpiScore(value) {
	if (value === null || value === undefined || value === "") {
		return "—"
	}
	const parsed = Number(value)
	if (!Number.isFinite(parsed)) {
		return "—"
	}
	return parsed.toFixed(1)
}

export function getKpiScoreTier(score) {
	if (score === null || score === undefined || score === "") {
		return null
	}
	const parsed = Number(score)
	if (!Number.isFinite(parsed)) {
		return null
	}
	if (parsed < KPI_TIER_RED_MAX) {
		return "red"
	}
	if (parsed > KPI_TIER_GREEN_MIN) {
		return "green"
	}
	return "yellow"
}
